import { getWeekdayByIndex } from "@/modules/boxSlotTemplate/boxSlotTemplateTypes"
import dayjs from "dayjs"

const WEEKDAY_INDEXES = [0, 1, 2, 3, 4, 5, 6] as const
type WeekdayIndex = (typeof WEEKDAY_INDEXES)[number]

function toWeekdayIndex(index: number): WeekdayIndex {
  switch (index) {
    case 0:
      return 0
    case 1:
      return 1
    case 2:
      return 2
    case 3:
      return 3
    case 4:
      return 4
    case 5:
      return 5
    case 6:
      return 6
    default:
      throw new Error(`Invalid weekday index: ${index}`)
  }
}

export const useLocaleWeekDays = () => {
  const firstDayOfWeek = dayjs.localeData().firstDayOfWeek()
  const weekdayIndexes = WEEKDAY_INDEXES.map((offset) => toWeekdayIndex((firstDayOfWeek + offset) % 7))

  const weekDaysArray = weekdayIndexes.map((localWeekDay) => {
    const weekDay = dayjs().day(localWeekDay)

    return {
      label: weekDay.format("dddd"),
      value: getWeekdayByIndex(localWeekDay),
    }
  })

  return weekDaysArray
}
